import React from "react"
import {trending, departments} from "./dummyData"
import ImageBanner from "../components/ImageBanner"
import {RoundelGrid} from "../components/RoundelGrid"
import styled from "styled-components"
import {useTheme} from "@irati/ui/src/global/useTheme"

const PayrollPayLandingScreen = () => {
  const theme = useTheme()
  return (
    <>
      <ImageBanner />

      <RoundelGrid roundels={trending} title="Trending" roundelBackgroundColor={theme.colors.greys.grey03} />

      <Section>
        <RoundelGrid roundels={departments} title="Departments" />
      </Section>
    </>
  )
}

export default PayrollPayLandingScreen

const Section = styled.div`
  width: 100%;
  background-color: ${({theme}) => theme.colors.greys.grey03};
`
